import { PagePermission } from 'src/app/core/interfaces/permissions';
import { Mobile } from '../mobile.setup';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

const parent = Mobile.pages.plans;
const title = 'PAGE.MOBILE.PLANS.TITLE';
const res = [
  'createPlan',
  'actions',
  'actions.editPlan',
  'actions.terminatePlan',
];

export const MobilePlansPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, null, res);
